import React, { Suspense, lazy } from 'react';
import Form from './form';
import Reviews from './reviews';
import { content } from '../content/textContent';
import LoadingSpinner from './LoadingSpinner';

const Karuselli = lazy(() => import('./carousel'));
const LazyImage = lazy(() => import('./lazyimage'));
const BackToTop = () => {
  return (
    <div className="fixed bottom-4 right-4 md:right-8 z-50 hover:scale-110 ease-in-out duration-300">
      <button
        className="bg-gray-800 text-white p-3 md:p-4 rounded-full shadow-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        onClick={() => {
          document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' });
        }}
        aria-label="Back to top"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 md:h-6 md:w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>
    </div>
  );
};

const sectionStyle =
  'relative flex flex-col min-h-[60vh] snap-center p-6 md:p-10 z-1 rounded-3xl justify-center items-center bg-white bg-opacity-70 text-gray-800 md:w-3/4 md:mx-auto font-medium text-base md:text-lg shadow-2xl backdrop-blur-sm border border-white border-opacity-20';

const carouselSectionStyle = 
  'relative flex flex-col min-h-[70vh] snap-center   z-1 justify-center items-center md:w-3/4 md:mx-auto backdrop-blur-sm ';

const pstyles = 'p-4 md:p-6 md:w-4/5 text-readable';
const Content = ({ isMobile }) => {
  return (
    <div className="p-2 md:p-4 space-y-16 md:space-y-24 mt-0 courgette-regular bg-bgimg bg-cover bg-no-repeat snap-y snap-mandatory md:pb-32">
      <BackToTop />
      <section id="home" className={`${sectionStyle} justify-evenly gap-8 md:gap-12`}>
        <Suspense fallback={<LoadingSpinner text="Loading image..." />}>
          <LazyImage src={'./images/front-1.jpg'} alt="Mirka" className="rounded-2xl max-w-64 md:max-w-72 shadow-lg" />
        </Suspense>
        <p className="text-lg md:text-xl md:w-4/5 text-center text-readable leading-relaxed">{content.home}</p>
        <p className="text-lg md:text-xl md:w-4/5 text-center text-readable leading-relaxed">{content.home2}</p>
      </section>

    {/* <section
  id="home"
  className="relative flex flex-col md:flex-row flex-wrap justify-center items-center min-h-[60vh] snap-center p-4 sm:p-6 md:p-8 lg:p-10 z-10 rounded-3xl bg-white bg-opacity-70 text-gray-800 w-full md:w-11/12 lg:w-3/4 mx-auto font-medium text-base sm:text-lg shadow-2xl backdrop-blur-sm border border-white border-opacity-20"
>
  <Suspense fallback={<LoadingSpinner text="Loading image..." />}>
    <LazyImage
      src={'./images/front-1.jpg'}
      alt="Mirka"
      className="rounded-2xl w-full max-w-[16rem] sm:max-w-[18rem] md:max-w-[20rem] lg:max-w-[22rem] shadow-lg mb-4 md:mb-0 md:mr-6"
    />
  </Suspense>
  <div className="flex flex-col justify-center items-center text-center space-y-4 md:space-y-6">
    <p className="text-base sm:text-lg md:text-xl text-readable leading-relaxed px-4">{content.home}</p>
    <p className="text-base sm:text-lg md:text-xl text-readable leading-relaxed px-4">{content.home2}</p>
  </div>
</section> */}
      <section id="karuselli" className={carouselSectionStyle}>
        <Suspense fallback={<LoadingSpinner text="Loading gallery..." />}>
          <Karuselli isMobile={isMobile} />
        </Suspense>
      </section>

      <section id="projects" className={`${sectionStyle}`}>
        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-center py-4 md:py-8 w-full md:w-4/5 leading-tight">
          Are you ready to make a change? Let's do this together!
        </h2>
        <div className={`${pstyles} text-base md:text-lg leading-relaxed`}>{content.p4}</div>
        <Reviews />
      </section>
      <section id="about" className={`${sectionStyle}`}>
        <h2 className="text-2xl md:text-3xl text-center font-bold py-4 mb-4">About me</h2>
        <p className={`${pstyles} text-center text-base md:text-lg leading-relaxed`}>{content.p5}</p>
        <p className={`${pstyles} text-center text-base md:text-lg leading-relaxed`}>{content.p1}</p>
        <p className={`${pstyles} text-center text-base md:text-lg leading-relaxed`}>{content.p2}</p>
        <p className={`${pstyles} text-center text-base md:text-lg leading-relaxed`}>{content.p3}</p>
      </section>
      <section id="contact" className={`${sectionStyle}`}>
        <Form />
      </section>
    </div>
  );
};

export default Content;

